<template>
  <div class="custom-spu-designer-content">
    <div class="design-top">
      <div class="logo-icon">
        <img src="../icon/console_logo.svg"
             class="logo"
             @click="() => { route.path !== '/' ? router.push('/') : '' }">
      </div>
      <div class="back-icon">
        <div class="back"
             @click="() => { router.go(-1) }">
          <img src="../icon/back.png">
          <span>{{ $t('CustomSpus.CustomSpuDesigner.back') }}</span>
        </div>
      </div>
      <div :class="['user', !isLogin ? '' : 'user-login']">
        <a-button v-if="!isLogin"
                  class="login-btn"
                  @click="login">{{ $t('CustomSpus.CustomSpuDesigner.loginRegister') }}</a-button>
        <component :is="'FlashbaseUserProfileControl'"
                   v-else>
          <template #design>
            <a-menu-item @click="designClick">
              <template #icon>
                <highlight-outlined />
              </template>
              {{ $t('CustomSpus.CustomSpuDesigner.goDesign') }}
            </a-menu-item>
          </template>
        </component>
      </div>
    </div>
    <div class="designer">
      <a-tabs v-model:activeKey="activeKey"
              tab-bar-gutter="0">
        <template #renderTabBar>
          <div class="tab-pane">
            <div :class="['tab', activeKey === '1' ? 'selected' : 'select', tutorialSteps === 1 ? 'tutorial-show' : '']"
                 @click="judgmentSelectProduct">
              {{ $t('CustomSpus.CustomSpuDesigner.selectProduct') }}
            </div>
            <div :class="['tab', activeKey === '2' ? 'selected' : 'select', tutorialSteps === 2 ? 'tutorial-show' : tutorialSteps === 3 ? 'tutorial-show' : '']"
                 @click="activeKey = '2'">
              {{ $t('CustomSpus.CustomSpuDesigner.myDesigns') }}
            </div>
          </div>
        </template>
        <a-tab-pane key="1"
                    class="tutorial-show"
                    :tab="$t('CustomSpus.CustomSpuDesigner.selectProduct')">
          <ul class="product-box">
            <li v-for="(item, index) in productArray"
                :key="index">
              <p class="product-category">{{ item.name }}</p>
              <div class="product-list">
                <a-popover v-for="(itm, j) in item.list"
                           :key="j"
                           :title="$t('CustomSpus.CustomSpuDesigner.productInfo')"
                           trigger="hover"
                           class="product-item"
                           placement="right"
                           @click="productItemClick(itm)">
                  <img class="product-list-img"
                       :src="itm.image" />
                  <template #content>
                    <div class="itemDetail">
                      <img :src="itm.image" />
                      <p class="title">{{ itm.name }}</p>
                      <div class="detail-txt">
                        <span>{{ $t('CustomSpus.CustomSpuDesigner.priceStartPrefix') }}{{ itm.price }}{{
                          $t('CustomSpus.CustomSpuDesigner.priceStartSuffix') }}</span>
                        <span>{{ $t('CustomSpus.CustomSpuDesigner.soldCountPrefix') }}{{ itm.sale_count }}</span>
                      </div>
                      <div class="detail-desc">
                        <p v-if="temporaryMaterial">{{ temporaryMaterial }}</p>
                        <p v-if="itm.deliver">{{ $t('CustomSpus.CustomSpuDesigner.deliveryTimePrefix') }}{{ itm.deliver
                        }}{{ $t('CustomSpus.CustomSpuDesigner.deliveryTimeSuffix') }}</p>
                        <p>{{ itm.desc }}</p>
                        <!-- <span v-if="temporarySize">尺码：{{ temporarySize }}</span> -->
                      </div>
                    </div>
                  </template>
                </a-popover>
              </div>
            </li>
          </ul>
        </a-tab-pane>
        <a-tab-pane key="2"
                    :tab="$t('CustomSpus.CustomSpuDesigner.myDesigns')">
          <div class="myDesign">
            <!-- 创建商品 -->
            <div class="myDesign-components">
              <CreateItemServicePages v-model:selectedColors="selectedColors"
                                      container-id="itemId"
                                      :class="tutorialSteps === 2 ? 'tutorial-show' : ''"
                                      :spu="currentSpu"
                                      :colors="availableColors"
                                      :is-area-customized="isAreaCustomized"
                                      :current-custom-area-scale="currentCustomAreaScale!"
                                      :is-login="isLogin"
                                      :is-customized="isCustomized"
                                      :is-external-procurement="isExternalProcurement"
                                      @change-external-procurement="changeExternalProcurementType"
                                      @upload-external-procurement-img="uploadExternalProcurementImg"
                                      @upload-external-procurement-loading="uploadExternalProcurementLoading"
                                      @customized-loading="changeCustomizedLoading"
                                      @to-login="login"
                                      @changes="uploadImage"
                                      @add-custom-text="addCustomText"
                                      @change-custom-spu-name="changeCustomSpuName" />
              <div class="complete">
                <a-button class="complete-button"
                          :disabled="!isCustomized"
                          type="primary"
                          @click="downloadCurrent">{{
                            $t('CustomSpus.CustomSpuDesigner.exportCurrentDesign') }}</a-button>
                <a-button class="complete-button"
                          :disabled="!isCustomized"
                          type="primary"
                          @click="download">{{
                            $t('CustomSpus.CustomSpuDesigner.exportALLDesign') }}</a-button>
                <a-button class="complete-button"
                          :disabled="!isCustomized"
                          type="primary"
                          @click="nameModalVisit = true">{{
                            $t('CustomSpus.CustomSpuDesigner.generateOrder') }}</a-button>
              </div>
            </div>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div class="custom-images">
        <div class="custom-select">
          <div class="custom-area">
            <template v-for="item in editingImages"
                      :key="item.image.id">
              <a-button class="custom-item"
                        :style="(currentEditingImage?.image.image === item.image.image || (item.image.id && item.image.id === currentEditingImage?.image.id)) ? 'background:black;color:white;' : 'color:#999999;'"
                        @click="onSelect(item)">{{
                          item.image.name[0]
                        }}</a-button>
            </template>
          </div>
          <div v-if="!isExternalProcurement"
               class="custom-scale">
            <template v-for="(item) in currentEditingImage?.image.scales"
                      :key="currentEditingImage?.image.id">
              <a-button class="custom-item"
                        :style="item.title === calcCustomScale(currentEditingImage?.image.id!)?.title ? 'background:black;color:white;' : 'color:#999999;'"
                        @click="selectFloatScale(item)">{{
                          item.title[0]
                        }}</a-button></template>
          </div>
          <div v-else
               class="custom-scale">
            <template v-for="(item) in externalCustomAreas"
                      :key="item.id">
              <a-button class="custom-item"
                        :style="item.id === currentEditingImage?.image.custom_areas.id ? 'background:black;color:white;' : 'color:#999999;'"
                        @click="selectExternalCustomArea(item)">{{
                          item.title!
                        }}</a-button></template>
          </div>
        </div>
        <div ref="editorContainer"
             class="editors">
          <a-spin :spinning="customImgLoading || savingLoading || segmentedLoading"
                  :tip="customImgLoading ? $t('CustomSpus.CustomSpuDesigner.painting') : savingLoading ? $t('CustomSpus.CustomSpuDesigner.framing') : externalProcurementLoading ? $t('CustomSpus.CustomSpuDesigner.updateTemplateImg') : $t('CustomSpus.CustomSpuDesigner.cutting')"
                  size="large">
            <ImageCustomizeEditor v-for="item in editingImages"
                                  :id="item.image.id + ''"
                                  :ref="createEditorRef(item)"
                                  :key="item.image.id"
                                  :class="(currentEditingImage?.image.id !== item.image.id || currentEditingImage.image.image !== item.image.image) ? 'hidden' : ''"
                                  :customized-area-scale="calcCustomScale(item.image.id)?.customized_areas_scale || 1"
                                  :container="editorContainerDom"
                                  :template-basic-parameters="templateBasicParameters(toUrl(findCustomableImage(currentColor as Color, item.image))!, currentColor!.value, item.image.width, item.image.height)"
                                  :custom-area="assignCustomArea(item)"
                                  :default-font="defaultFont"
                                  mode="edit"
                                  @img-loading="imgLoading"
                                  @custom-active-object="activeObject"
                                  @ready="item.onReady"
                                  @customized="onCustomized"
                                  @drag-drop="dragDrop" />
          </a-spin>
        </div>
        <!-- 颜色块 -->
        <div v-if="!isExternalProcurement"
             class="color-list">
          <div v-for="color in availableColors"
               :key="color.value"
               class="color-item-border">
            <a-tooltip>
              <template #title>{{ color.name }}</template>
              <a-avatar :class="['color-item', selectedColors.find(r => r.value === color.value) ? 'selected-color' : '']"
                        shape="square"
                        :alt='color.name'
                        :style="[color.image ? `backgroundImage:url(${color.image})` : '', `backgroundColor:${color.value}`]"
                        @click="onSelectColor(color)">
              </a-avatar>
            </a-tooltip>
          </div>
        </div>
      </div>
      <div class="preview">
        <CustomServiceEdit :three-dimensional-models-info="threeDimensionalModelsInfo[0]"
                           :canvas-active-object="canvasActiveObject!"
                           :background-color="currentColor?.value || '#fffffff'"
                           :segment-img="segmentImg"
                           :re-create="oneditable()"
                           @replace-img="replaceImg"
                           @on-default-font="onDefaultFont"
                           @on-custom-area-adjustment="onCustomAreaAdjustment" />
      </div>
    </div>
    <a-modal v-model:visible="loginVisible"
             wrap-class-name="fb_designer_modal_wrap"
             class="fb_designer_modal"
             :footer="null"
             :width="500">
      <FlashbaseSystemLogo />
      <iota-simple-signin :options="{ newWindowToResetPassword: true }"
                          @success="loginSuccess"></iota-simple-signin>
    </a-modal>
    <DesignOrder :custom-spu-id="customSpuId"
                 :open-design-order-visible="desginOrderVisit"
                 @close-visit="desginOrderVisit = false" />
    <a-modal v-model:visible="externalProcurementVisit"
             :title="$t('CustomSpus.CustomSpuService.basicInformation')"
             width="1300px"
             :ok-button-props="{ loading: externalProcurementModalLoading }"
             @ok="comfirmExternalProcurementBasicParameter">
      <a-form ref="formRef"
              name="dynamic_form_nest_item"
              :model="externalProcurementBasicParameter">
        <a-space v-for="(parameter, index) in externalProcurementBasicParameter"
                 :key="index"
                 style="display: flex; margin-bottom: 8px"
                 align="baseline">
          <a-form-item :label="$t('CustomSpus.CustomSpuService.color')"
                       :rules="{
                         required: true,
                         message: $t('CustomSpus.CustomSpuService.selectColor'),
                       }">
            <a-select v-model:value="parameter.color"
                      class="external-select"
                      label-in-value
                      :field-names="{ label: 'name', value: 'value' }"
                      :options="colorsOptions">
            </a-select>
          </a-form-item>
          <a-form-item :label="$t('CustomSpus.CustomSpuService.size')"
                       :rules="{
                         required: true,
                       }">
            <a-select v-model:value="parameter.size"
                      class="external-select"
                      :options="sizeOptions.map(item => ({ value: item }))"></a-select>
          </a-form-item>
          <a-form-item :label="$t('CustomSpus.CustomSpuService.technology')"
                       :rules="{
                         required: true,
                       }">
            <div>
              <templete v-for="(item, i) in parameter.technology"
                        :key="item.customableImageName">
                <a-cascader v-model:value="parameter.selectedTechnology"
                            :options="technologyOptions[0].children"
                            @change="handleChange(parameter, i)">
                  <span> {{ item.customableImageName + '/' + item.name }} &nbsp;</span>
                </a-cascader>
              </templete>
            </div>
          </a-form-item>
          <a-form-item :label="$t('CustomSpus.CustomSpuService.quantity')"
                       :rules="{
                         required: true,
                       }">
            <a-input-number v-model:value="parameter.quality"
                            :min="1"
                            :max="10000000" />
          </a-form-item>
          <MinusCircleOutlined @click="removeSight(parameter)" />
        </a-space>
        <a-form-item>
          <a-button type="dashed"
                    block
                    @click="addSight">
            <PlusOutlined />
            {{ $t('CustomSpus.CustomSpuService.addShape') }}
          </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model:visible="nameModalVisit"
             :title="$t('CustomSpus.CustomSpuService.enterName')"
             :ok-button-props="{ loading: nameModalConfirm }"
             @ok="complete">
      <a-input v-model:value="currentCustomSpuName"
               :placeholder="isExternalProcurement ? $t('CustomSpus.CustomSpuService.externalProcurementOrder') : currentSpu?.name" />
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { toUrl } from "@/utils"
import { ImageCustomizeEditor } from '@iota-cn/ui-components'
// import ImageCustomizeEditor from './ImageCustomizeEditor.vue'
import DesignOrder from "./components/DesignOrder.vue"
import { computed, onMounted, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
// import ThreeDimensional from "./ThreeDimensional.vue"
import { useRoute, useRouter } from 'vue-router'
import { categories, categoriesDetail } from '../../home/api/index'
import { getCustomSpu, submitCustomSpu, uploadCustomImage, submitExternalCustomSpu, getTechnology } from '../api/index'
import { EditingImage, type Color, type CustomizedAreasScale, type NewExternalCustomSpu, type CustomAreas, type TechnologyOptions, type ExternalCustomableImage, type ExternalProcurementBasicParameter, type CustomizedImage, type SelectedDssThemeList, type CustomPrice, type DssCustomizedImage, type Technology, type NewCustomSpu, type BuyDssTheme, type Spu, type ThreeDimensionalModelInfo } from '../types'
import { findCustomableImage, templateBasicParameters, convertImageAndColor } from "../utils"
import CreateItemServicePages from './components/CreateItemServicePages.vue'
import CustomServiceEdit from "./components/CustomServiceEdit.vue"
import type { UserService } from '@/core'
import { CORE_USER } from '@/core/CoreSymbol'
import type { LoginPageOption, LoginPageService, Plugin } from '@/plugins'
import { PLUGIN_AUTH } from '@/plugins/builtin/BuiltinPluginSymbol'
import Cookie from 'js-cookie'
import { container } from 'tsyringe'
import type { categoriesMenusState } from "../../shop/api/interface/categoriesInterface"
import JSZip from "jszip"
import { selectedSpuData } from "../../index"
import { message } from "ant-design-vue"
import BigNumber from "bignumber.js"
import { saveAs } from "file-saver"
BigNumber.config({ ROUNDING_MODE: 1 })
type FabricElement = InstanceType<typeof ImageCustomizeEditor>
const colorsOptions = ref<Color[]>([{ "name": "BLACK 黑色", "value": "#060606" }, { "name": "RED 红色 200C", "value": "#ab181d" }, { "name": "ROYAL 宝蓝 287C", "value": "#002d69" }, { "name": "NAVY 藏青 5395C", "value": "#000f21" }, { "name": "GREEN 绿色 3425C", "value": "#005135" }, { "name": "PINK 粉色 217C", "value": "#f7afe9" }, { "name": "ORANGE 橘色 1495C", "value": "#fc6933" }, { "name": "MAROON 枣红色 490C", "value": "#3c0914" }, { "name": "YELLOW 黄色 114C", "value": "#ffcb8b" }, { "name": "GREY HTR浅麻灰", "value": "#ddd9d9" }, { "name": "GUNMETAL HEATHER麻灰", "value": "#817e7e" }, { "name": "WHITE 白色", "value": "#f4f5fc" }])
const sizeOptions = ref<string[]>(['S', 'M', 'L', 'XL', 'XXL', 'XXXL'])
const externalCustomableImage = ref<ExternalCustomableImage[]>([
  { id: 99999998, name: '正面', image: 'https://flashbase-product.oss-cn-hangzhou.aliyuncs.com/upload/alt_images/711a5811-bcc5-4d0c-94a0-a6f07ef51e20/94f6361e-e158-4f83-a94d-ac2fa90809ac/1.jpg', width: 2000, height: 2000, custom_areas: { id: 4, title: '16x18', dpi: 30, top: 231, left: 320, scale: 8, width: 420, height: 480, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 } },
  { id: 99999999, name: '背面', image: 'https://flashbase-product.oss-cn-hangzhou.aliyuncs.com/upload/alt_images/711a5811-bcc5-4d0c-94a0-a6f07ef51e20/4caa2921-0759-4216-96ab-df047ddd84a6/1-1.jpg', width: 2000, height: 2000, custom_areas: { id: 4, title: '16x18', dpi: 30, top: 231, left: 320, scale: 8, width: 420, height: 480, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 } }
])
const externalCustomAreas = ref<CustomAreas[]>([
  { id: 1, title: '7x8', dpi: 30, top: 231, left: 437, scale: 8, width: 184, height: 214, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 },
  { id: 2, title: '10x12', dpi: 30, top: 231, left: 398, scale: 8, width: 263, height: 320, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 },
  { id: 3, title: '14x16', dpi: 30, top: 231, left: 345, scale: 8, width: 368, height: 427, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 },
  { id: 4, title: '16x18', dpi: 30, top: 231, left: 319, scale: 8, width: 420, height: 480, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 },
  { id: 5, title: '16x21', dpi: 30, top: 231, left: 319, scale: 8, width: 420, height: 561, bgWidth: 1058, bgHeight: 1058, templateWidth: 2000, templateHeight: 2000 },
])
// const externalCustomArea = ref<CustomAreas[]>([{ dpi: 30, top: 231, left: 320, scale: 8, width: 420, height: 480, bgWidth: 1058, bgHeight: 1058 }])
const isCustomized = ref<boolean>(false)
const isAreaCustomized = ref<CustomPrice[]>([])
const currentCustomAreaScale = ref<CustomizedAreasScale[]>([])
const selectedDssThemeList = ref<SelectedDssThemeList[]>([])
const isLogin = computed(() => {
  const userService = container.resolve<UserService>(CORE_USER)
  const loginOptions = container.resolve<Plugin<LoginPageOption, LoginPageService>>(PLUGIN_AUTH)
  const isUserValid = userService.isUserValid()
  const cookie = Cookie.get(loginOptions.options.cookieKey || 'iota')
  const isLogged = isUserValid && cookie && cookie.length > 0
  return isLogged
})
const externalProcurementModalLoading = ref<boolean>(false)
const nameModalConfirm = ref<boolean>(false)
const nameModalVisit = ref<boolean>(false)
const segmentedLoading = ref<boolean>(false)
const segmentImg = ref<string>('')
const currentCustomSpuName = ref<string>('')
const tutorialStepClass = ref<string[]>(['tutorial-step-first', 'tutorial-step-second', 'tutorial-step-third', 'tutorial-step-fourth', 'tutorial-step-fifth'])
const customImgLoading = ref<boolean>(false)
const savingLoading = ref<boolean>(false)
const currentCustomSpuData = selectedSpuData()
const currentCustomSpuDataJson = currentCustomSpuData.pathJudgment()
const tutorialSteps = ref<number>(0)
const defaultFont = ref<'SimSun' | 'PingFang SC'>()
const canvasActiveObject = ref<object>()
const route = useRoute()
const router = useRouter()
const { t } = useI18n()
const categoryId = ref<string>(route.query.categoryId as any ?? 0)
const spuId = ref<string>(route.query.spuId as any ?? 0)
const threeDimensionalModelsInfo = ref<Array<ThreeDimensionalModelInfo>>([])
const loginVisible = ref<boolean>(false)
const currentSpu = ref<Spu>()
const editingImages = ref<EditingImage[]>([])
const productArray = ref<categoriesMenusState['categories'] | any>()
const activeKey = ref('2')
const isExternalProcurement = ref<boolean>(false)
const externalProcurementImg = ref<string>('')
const externalProcurementLoading = ref<boolean>(false)
const externalProcurementVisit = ref<boolean>(false)
const externalProcurementBasicParameter = ref<ExternalProcurementBasicParameter[]>([])
const desginOrderVisit = ref<boolean>(false)
const customSpuId = ref<string>('')
const technologyOptions = ref<TechnologyOptions[]>([])
/**
 *组件变量
 */
const currentEditingImage = ref<EditingImage>()

/**
 *颜色
 */
const availableColors = ref<Color[]>([])
const selectedColors = ref<Color[]>([])
const currentColor = ref<Color>()
const editorContainer = ref()
const editorContainerDom = computed(() => {
  return editorContainer.value
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const allImageEditors: any = {}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createEditorRef = (item: any) => {
  return (el: any) => {
    if (el) {
      const id = el.editorId() // 假设每个 editor 有 editorId 方法
      allImageEditors[id] = el
      item.fabric = el // 同时设置 item.fabric
      // console.log(item.editorId());

    }
  }
}

watch(() => tutorialSteps.value, () => {
  if (!tutorialSteps.value || tutorialSteps.value > tutorialStepClass.value.length) {
    tutorialSteps.value = 0
    localStorage.setItem('isTutorialReaded', 'true')
  }
})

watch(selectedColors, (newColors) => {
  currentColor.value = newColors[newColors.length - 1]
}, { deep: true })

watch(() => activeKey.value, () => {
  if (activeKey.value === '1') {
    productArray.value.forEach((item: any) => {
      if (item.list)
        return
      categoriesDetail(item.id as number).then(result => {
        if (result.spus.length > 0) {
          item.list = result.spus
        }
      })
    })
  }
})

const handleChange = (selectedValues: ExternalProcurementBasicParameter, index: number) => {
  selectedValues.technology[index].name = selectedValues.selectedTechnology![0]
}

const addSight = () => {
  const technologies = technologyOptions.value.map(r => ({
    customableImageName: r.value,
    name: t('CustomSpus.CustomSpuService.clickSeleted'),
  }))
  externalProcurementBasicParameter.value.push({
    color: {
      name: '',
      value: ''
    },
    selectedTechnology: [],
    size: '',
    quality: 0,
    technology: technologies
  })
}

const removeSight = (item: ExternalProcurementBasicParameter) => {
  const index = externalProcurementBasicParameter.value.indexOf(item)
  if (index !== -1) {
    externalProcurementBasicParameter.value.splice(index, 1)
  }
}

const changeExternalProcurementType = (isExternal: boolean) => {
  if (isExternal) {
    isExternalProcurement.value = isExternal
    categoryId.value = '150'
    spuId.value = '60'
    isCustomized.value = false
    initDesignData()
  } else {
    categoryId.value = '22'
    spuId.value = '28'
    isExternalProcurement.value = false
    initDesignData()
  }
}

const downloadCurrent = async () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const images: any = {}
    let el: any
    const isCustomizedArea = [] as { name: string, id: number }[]
    isCustomizedArea.push({
      name: currentSpu.value?.name + '-' + currentEditingImage.value!.image.name,
      id: currentEditingImage.value!.image.id
    })
    // 遍历 allImageEditors 并处理符合条件的键
    Object.keys(allImageEditors).forEach((key) => {
      const id = Number(key)
      const matchingArea = isCustomizedArea.find((area) => area.id === id)
      if (matchingArea) {
        el = allImageEditors[key] as FabricElement
        const data = el.exportFullImageAsBlob()
        images.name = matchingArea.name
        images.data = data
      }
    })

    const imageUrl = window.URL.createObjectURL(images.data)
    const fileName = `${images.name}.jpg`
    saveAs(images.data, fileName)
    window.URL.revokeObjectURL(imageUrl)
  } catch (error) {
    message.error(t('CustomSpus.CustomSpu.networkError'))
    console.log(error)
  }
}

// 批量下载合成图
const download = () => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const images: any = []
    const zip = new JSZip()
    let el: any
    const isCustomizedArea = [] as { name: string, id: number }[]
    editingImages.value.forEach((element) => {
      if (element.fabric.isCustomized())
        isCustomizedArea.push({
          name: currentSpu.value?.name + '-' + element.image.name,
          id: element.image.id
        })
    })
    // 遍历 allImageEditors 并处理符合条件的键
    Object.keys(allImageEditors).forEach((key) => {
      const id = Number(key)
      const matchingArea = isCustomizedArea.find((area) => area.id === id)
      if (matchingArea) {
        el = allImageEditors[key] as FabricElement
        const data = el.exportFullImageAsBlob()
        images.push({
          name: matchingArea.name,
          data
        })
      }
    })
    Promise.all(images).then((img) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      img.forEach((element: any) => {
        zip.file(`${element.name}-${new Date().getTime()}.png`, element.data, {
          base64: true
        })
      })
      zip.generateAsync({ type: "blob" }).then(function (content) {
        saveAs(content, currentSpu.value?.name || 'download')
      })
    })
  } catch (error) {
    message.error(t('CustomSpus.CustomSpu.networkError'))
    console.log(error)
  }
}


// 图片切换
const onSelect = (image: EditingImage) => {
  currentEditingImage.value = image
  canvasActiveObject.value = currentEditingImage.value?.fabric.currentSelectionActiveObject()
  const info = threeDimensionalModelsInfo.value
  info?.forEach((r: any) => {
    const relevanceNode = r.relevanceNodes.find((res: any) => res.customImageId == image.image.id)
    if (relevanceNode) {
      if (!r.relevanceSwatch.find((result: any) => result.currentLocation == relevanceNode.node)) {
        r.relevanceSwatch.push({
          currentLocation: relevanceNode.node,
          texture: '',
          customImageId: relevanceNode.customImageId
        })
      }
    }
  })
}

const oneditable = () => {
  if (selectedDssThemeList.value.length) {
    const existingEditingIndex = selectedDssThemeList.value.findIndex((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
    if (existingEditingIndex >= 0) {
      return (!!selectedDssThemeList.value[existingEditingIndex]?.buyDssThemeList.find((r: BuyDssTheme) => r.dsstheme?.shareable) && currentEditingImage.value?.fabric.isCustomized()) || false
    } else {
      return true
    }
  } else
    return true
}

const replaceImg = (imgUrl: string) => {
  segmentedLoading.value = true
  currentEditingImage.value?.fabric.replaceImg(imgUrl)
}

const assignCustomArea = (item: any) => {
  return Object.assign({}, item.image.custom_areas, { json: item.json })
}

const dragDrop = (operation: string, value: boolean) => {
  if (operation === 'scaling') {
    currentCustomSpuData.customAreaAdjustment.maximize = value
    currentCustomSpuData.customAreaAdjustment.spreadOut = value
    currentCustomSpuData.customAreaAdjustment.heightMaximization = value
    currentCustomSpuData.customAreaAdjustment.widthMaximization = value
  } else if (operation === 'flipHorizontal') {
    currentCustomSpuData.customAreaAdjustment.flipHorizontal = value
  } else {
    currentCustomSpuData.customAreaAdjustment.flipVertical = value
  }
}

const uploadExternalProcurementImg = (img: string) => {
  externalProcurementImg.value = img
  editingImages.value.forEach((element) => {
    if (element.image.image === currentEditingImage.value!.image.image) {
      currentEditingImage.value!.image.image = img
    }
  })
}

const uploadExternalProcurementLoading = (bool: boolean) => {
  externalProcurementLoading.value = bool
}

const imgLoading = (loading: boolean) => {
  customImgLoading.value = loading
}

const activeObject = (selected: any, segmentImgUrl?: string) => {
  if (segmentImgUrl)
    segmentImg.value = segmentImgUrl
  else
    segmentImg.value = ''

  canvasActiveObject.value = selected
  segmentedLoading.value = false
}

const changeCustomSpuName = (value: string) => {
  currentCustomSpuName.value = value
}

const temporaryMaterial = computed(() => {
  let materialFilter: any = false
  productArray.value.forEach((item: any) => {
    if (item.list && item.list.length > 0) {
      item?.list.forEach((itm: any) => {
        materialFilter = itm.attrs.find((i: any) => {
          return i.attribute.key == 'material'
        })
      })
    }
  })
  return materialFilter?.value
})

const login = () => {
  loginVisible.value = true
}

const designClick = () => {
  router.push('/console/products/spus')
}

const onSelectColor = (color: Color) => {
  currentColor.value = color
  const currentColorIndex = selectedColors.value.findIndex(r => r.value === color.value)
  if (currentColorIndex === -1)
    selectedColors.value.push(color)
  else
    selectedColors.value.splice(currentColorIndex, 1)
}

const onDefaultFont = (value: 'SimSun' | 'PingFang SC') => {
  defaultFont.value = value
}

const addCustomText = () => {
  if (!oneditable()) {
    message.error(t('CustomSpus.CustomSpuDesigner.noRedesign'))
  } else {
    currentEditingImage.value?.fabric.addTextToCustomArea(t('CustomSpus.CustomSpuDesigner.doubleClickToEdit'))
  }
}

const changeCustomizedLoading = (type: boolean) => {
  customImgLoading.value = type
}

/**
 *上传图片
 */
const uploadImage = (image: string) => {
  if (!oneditable()) {
    message.error(t('CustomSpus.CustomSpuDesigner.noRedesign'))
  } else {
    const waitCanvas = setInterval(() => {
      if (currentEditingImage.value && currentEditingImage.value?.fabric) {
        currentEditingImage.value?.fabric.addImageToCustomArea(image)
        clearInterval(waitCanvas)
      }
    }, 300)
  }
}

onMounted(async () => {
  await getTechnology().then(res => {
    const technology = res.data.items.map((r: any) => {
      return {
        label: r.name,
        value: r.name
      }
    })
    externalCustomableImage.value.forEach((r: ExternalCustomableImage) => {
      technologyOptions.value.push({
        label: r.name,
        value: r.name,
        children: technology
      })
    })
  })
  await categories().then(result => {
    productArray.value = result.categories
  }).then(() => {
    // 生成特定产品详情
    if (categoryId.value && spuId.value) initDesignData()
    else {
      productArray.value.forEach(async (item: any) => {
        await categoriesDetail(item.id as number).then(result => {
          if (result.spus.length > 0) {
            item.list = result.spus
            if (!categoryId.value && !spuId.value) {
              // 随机生成产品详情
              categoryId.value = item.list[0].category_id
              spuId.value = item.list[0].id
              initDesignData()
            }
          }
        })
      })
    }
    if (!localStorage.getItem('isTutorialReaded'))
      tutorialSteps.value = 1
  })

  if (route.query.image) {
    uploadImage(`${route.query.image}width=800&height=800`)
  }
})

const productItemClick = async (data: any) => {
  currentSpu.value = data
  selectedColors.value = []
  availableColors.value = convertImageAndColor(data)
  if (availableColors.value.length > 0) {
    if (selectedColors.value.length < 1)
      selectedColors.value.push(availableColors.value[0])
    currentColor.value = availableColors.value[0]
  }
  editingImages.value = (data.customableImages || []).map((i: any) => {
    return new EditingImage(i as CustomizedImage)
  })
  currentEditingImage.value = editingImages.value[0]

  editingImages.value.forEach((r: any) => {
    const currentScale = r.image.scales.find((rr: any) => Number(rr.customized_areas_scale) === 1)
    if (currentScale) {
      currentCustomAreaScale.value.push({
        customable_image_id: r.image?.id,
        discount_amount_scale: currentScale?.discount_amount_scale,
        customized_areas_scale: currentScale?.customized_areas_scale,
        title: currentScale?.title
      })
    } else {
      currentCustomAreaScale.value.push({
        customable_image_id: r.image?.id,
        discount_amount_scale: r.image.scales[0]?.discount_amount_scale,
        customized_areas_scale: r.image.scales[0]?.customized_areas_scale,
        title: r.image.scales[0]?.title
      })
    }
  })
  canvasActiveObject.value = undefined
  isExternalProcurement.value = false
}

const initDesignData = async () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const res: any = await getCustomSpu(categoryId.value, spuId.value)
  const spu: Spu = res as Spu
  currentSpu.value = spu
  if (isExternalProcurement.value) {
    editingImages.value = externalCustomableImage.value.map((i) => {
      return new EditingImage(i as CustomizedImage)
    })
    currentEditingImage.value = editingImages.value[0]
    canvasActiveObject.value = undefined
  } else {
    spu.attrs = spu.attrs || []
    availableColors.value = convertImageAndColor(res)
    editingImages.value = (spu?.customableImages || []).map((i) => {
      return new EditingImage(i as CustomizedImage)
    })
    if (currentCustomSpuDataJson) {
      currentCustomSpuName.value = currentCustomSpuDataJson.name
      currentCustomAreaScale.value = currentCustomSpuDataJson.price_detail.custom_price!.map((r: any) => {
        return {
          customable_image_id: r.id,
          customized_areas_scale: r.customized_areas_scale,
          discount_amount_scale: r.discount_amount_scale,
          title: r.customized_areas_scale_title
        }
      })

      isAreaCustomized.value = currentCustomSpuDataJson.price_detail.custom_price!

      const rawData: Color[] = []
      currentCustomSpuDataJson.customSkus.forEach((r: any) => rawData.push(r.color))
      rawData.forEach((r: any) => {
        if (!selectedColors.value.find((rr: any) => rr.name === r.name))
          selectedColors.value.push(r)
      })

      editingImages.value.forEach((r: any) => {
        const currentJson = currentCustomSpuDataJson.customizedImages.find((rr: any) => rr.customableImage.id === r.image.id)?.customized_json
        if (currentJson) r.json = currentJson
      })

      currentColor.value = selectedColors.value.find((r: any) => r.value === currentCustomSpuDataJson!.customizedImages[0].customized_json.background)
    } else if (editingImages.value.length) {
      currentEditingImage.value = editingImages.value[0]
      editingImages.value.forEach((r: any) => {
        const currentScale = r.image.scales.find((rr: any) => Number(rr.customized_areas_scale) === 1)

        if (currentScale) {
          currentCustomAreaScale.value.push({
            customable_image_id: r.image.id,
            discount_amount_scale: currentScale.discount_amount_scale,
            customized_areas_scale: currentScale.customized_areas_scale,
            title: currentScale.title
          })
        } else {
          currentCustomAreaScale.value.push({
            customable_image_id: r.image.id,
            discount_amount_scale: r.image.scales.length ? r.image.scales[0].discount_amount_scale : 1,
            customized_areas_scale: r.image.scales.length ? r.image.scales[0].customized_areas_scale : 1,
            title: r.image.scales.length ? r.image.scales[0].title : '默认'
          })
        }
        if (availableColors.value.length > 0) {
          if (selectedColors.value.length < 1)
            selectedColors.value.push(availableColors.value[0])
          currentColor.value = availableColors.value[0]
        }
      })
    }
  }
}

const judgmentSelectProduct = () => {
  if (!currentCustomSpuData.customSpu)
    activeKey.value = '1'
  else
    message.info(t('CustomSpus.CustomSpuDesigner.cannotChangeProduct'))
}

const nologin = () => {
  const userService = container.resolve<UserService>(CORE_USER)
  const user = userService.getUser()
  if (Object.entries(user.value).length < 1) {
    loginSuccess()
    return true
  }
  return false
}

const createCustomSpu = async (isExternal: boolean = false) => {
  if (nologin()) {
    return
  }
  const customSpu: NewCustomSpu = { spu_id: 0, name: '', customizedImages: [] }
  if (isExternal) {
    customSpu.baseData = externalProcurementBasicParameter.value
    customSpu.baseData.forEach((r: ExternalProcurementBasicParameter) => {
      delete r.selectedTechnology
    })
    customSpu.name = currentCustomSpuName.value || '外采订单'
    customSpu.price = 0
    customSpu.spu_id = 60
  } else {
    customSpu.spu_id = currentSpu.value?.id
    customSpu.colors = selectedColors.value
    customSpu.name = currentCustomSpuName.value || currentSpu.value?.name
    customSpu.price = currentSpu.value?.price || 0
  }

  const imgPromises: Array<Promise<string>>[] = []
  editingImages.value.forEach((element) => {
    if (element.fabric.isCustomized()) {
      let custom = {} as any
      if (isExternal) {
        custom = {
          custom_area_id: element.image.id,
          custom_areas: Object.assign({}, element.image.custom_areas, { name: element.image.name }),
          spu_customable_image: element.image.image,
          customized_image: '',
          customized_json: {},
          customized_areas: { customable_image_scale: 8, customized_areas_scale: 1, discount_amount_scale: 1, boundingRect: {}, },
        }
      } else {
        const currentScale = currentCustomAreaScale.value.find((r: any) => r.customable_image_id === element.image.id)
        custom = {
          custom_area_id: element.image.custom_areas.id,
          spu_customable_image_id: element.image.id,
          customized_image: '',
          customized_json: {},
          customized_areas: { customable_image_scale: element.image.custom_areas.scale || 2, customized_areas_scale: currentScale!.customized_areas_scale || 1, discount_amount_scale: currentScale!.discount_amount_scale || 1, boundingRect: {} },
        }
      }
      customSpu.customizedImages?.push(custom)
      imgPromises.push(element.fabric.exportVisualCustomAreaImageAsBlobAsync().then((
        { blob, boundingRect }: { blob: Blob, boundingRect: { left: number, top: number, width: number, height: number } }
      ) => {
        custom.customized_areas.boundingRect = boundingRect
        return uploadCustomImage(blob).then((image: string) => {
          custom.customized_image = image
          custom.customized_json = element.fabric.exportCustomAreaJson()
        }).catch((res: any) => {
          if (res.detail === "unsupported size")
            message.error(t('CustomSpus.CustomSpuDesigner.designTooLarge'))
          else
            message.error(t('CustomSpus.CustomSpuDesigner.designNotCompliant'))
        })
      }))
    }
  })
  await Promise.all(imgPromises)
  return customSpu
}

const comfirmExternalProcurementBasicParameter = () => {
  externalProcurementModalLoading.value = true
  const confirmData = externalProcurementBasicParameter.value.every((item: ExternalProcurementBasicParameter) => {
    const check = item.technology.some(r => {
      if (r.name === t('CustomSpus.CustomSpuService.clickSeleted'))
        return true
      else
        return false
    })
    if (check) {
      message.error(t('CustomSpus.CustomSpuService.selectTechnology'))
      externalProcurementModalLoading.value = false
      return false
    }
    if (item.color.label && !item.color.label) {
      message.error(t('CustomSpus.CustomSpuService.selectColor'))
      externalProcurementModalLoading.value = false
      return false
    }
    if (!item.color.value) {
      message.error(t('CustomSpus.CustomSpuService.selectColor'))
      externalProcurementModalLoading.value = false
      return false
    }
    if (!item.size) {
      message.error(t('CustomSpus.CustomSpuService.selectTechnology'))
      externalProcurementModalLoading.value = false
      return false
    }
    if (item.quality === 0) {
      message.error(t('CustomSpus.CustomSpuService.inputQuantity'))
      externalProcurementModalLoading.value = false
      return false
    }
    return true
  })

  if (!confirmData)
    return

  externalProcurementBasicParameter.value.forEach((item: ExternalProcurementBasicParameter) => {
    item.color = {
      name: item.color.label!,
      value: item.color.value
    }
  })

  savingLoading.value = true

  createCustomSpu(true).then(async (customSpu) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customSpuData = Object.assign(customSpu!, { selectedDssThemeList: selectedDssThemeList.value })
    await submitExternalCustomSpu(customSpuData as NewExternalCustomSpu).then((res: any) => {
      customSpuId.value = res.id
      desginOrderVisit.value = true
      externalProcurementVisit.value = false
      externalProcurementModalLoading.value = false
    }).catch(() => {
      externalProcurementModalLoading.value = false
      message.error('生成失败，请重试或者联系客服')
    })
  })
  savingLoading.value = false
}

const complete = async () => {
  nameModalConfirm.value = true
  if (isExternalProcurement.value) {
    const technologies = technologyOptions.value.map(r => ({
      customableImageName: r.value,
      name: '请点击选择',
    }))
    externalProcurementBasicParameter.value = []
    externalProcurementBasicParameter.value.push({
      color: {
        name: '',
        value: ''
      },
      selectedTechnology: [],
      size: '',
      quality: 0,
      technology: technologies
    })
    externalProcurementVisit.value = true
    nameModalConfirm.value = false
    nameModalVisit.value = false
  } else {
    savingLoading.value = true
    createCustomSpu().then(async (customSpu) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const customSpuData = Object.assign(customSpu!, { selectedDssThemeList: selectedDssThemeList.value })
      await submitCustomSpu(customSpuData).then((res: any) => {
        customSpuId.value = res.id
        desginOrderVisit.value = true
      }).catch(() => {
        message.error('生成失败，请重试或者联系客服')
      })
      // router.push(`/console/products/custom_spus/${res.id}`)
      savingLoading.value = false
      nameModalConfirm.value = false
      nameModalVisit.value = false
    }).catch(() => {
      savingLoading.value = false
    })
  }
}

const calcCustomScale = (image_id: number) => {
  return currentCustomAreaScale.value.find((r: any) => r.customable_image_id === image_id)
}

const onCustomAreaAdjustment = (adjustment: any) => {
  if (!currentEditingImage.value)
    return

  currentEditingImage.value?.fabric.updateCustomArea(adjustment)
}

const selectExternalCustomArea = (item: CustomAreas) => {
  editingImages.value.forEach(r => {
    if (r.image.name === currentEditingImage.value?.image.name)
      r.image.custom_areas = item
  })
}

const selectFloatScale = (scale: any) => {
  const currentScale = calcCustomScale(currentEditingImage.value?.image.id!)
  if (!currentScale)
    return

  currentScale.title = scale.title
  currentScale.customized_areas_scale = scale.customized_areas_scale
  currentScale.discount_amount_scale = scale.discount_amount_scale

  if (!isAreaCustomized.value.length)
    return

  const discountScale = isAreaCustomized.value.find((r) => r.name === currentEditingImage.value?.image.name)
  discountScale!.customized_areas_scale = scale.customized_areas_scale
  discountScale!.discount_amount_scale = scale.discount_amount_scale
  discountScale!.customized_areas_scale_title = scale.title
}

const onCustomized = (deleteUrl?: String) => {
  if (!currentEditingImage.value)
    return

  const currentScale = calcCustomScale(currentEditingImage.value?.image.id!)

  if (!currentScale && !isExternalProcurement.value)
    return
  let existenceCustomization = false
  editingImages.value.forEach(r => {
    if (r.fabric.isCustomized())
      existenceCustomization = true
  })
  const findCurrentEditingIndex = isAreaCustomized.value.findIndex((r: CustomPrice) => r.name === currentEditingImage.value?.image.name)
  const existingEditingIndex = selectedDssThemeList.value.findIndex((r: SelectedDssThemeList) => r.product_spu_customable_image_id === currentEditingImage.value?.image.id)
  if (existenceCustomization) {
    isCustomized.value = true
    let calcDssImagePrice = '0'
    if (existingEditingIndex >= 0) {
      selectedDssThemeList.value[existingEditingIndex].buyDssThemeList.forEach((res: BuyDssTheme) => {
        if (res.dsstheme?.type != '1' && res.dsstheme?.type != '2' && !res.dsstheme?.free) {
          res.selectedCustomizedImages.forEach((r: DssCustomizedImage) => {
            calcDssImagePrice = new BigNumber(calcDssImagePrice).plus(r.ref_price).toFixed(2)
          })
        }
      })
    }
    if (findCurrentEditingIndex === -1) {
      let minTechnologyPrice = {
        id: 0,
        name: '',
        price: 0
      } as Technology
      if (currentEditingImage.value?.image.technologies?.length) {
        minTechnologyPrice = currentEditingImage.value?.image.technologies[0]
        currentEditingImage.value?.image.technologies.forEach((r: Technology) => {
          if (minTechnologyPrice.price > r.price)
            minTechnologyPrice = r
        })
      }
      const data: {
        name: string
        price: string
        discount_amount_scale: string
        customized_areas_scale: string
        customized_areas_scale_title: string
        technology: Technology
        dss_image_price?: string
      } = {
        name: currentEditingImage.value.image.name,
        price: currentEditingImage.value.image.price?.toString() || '0.00',
        discount_amount_scale: currentScale?.discount_amount_scale.toString() || '0.00',
        customized_areas_scale: currentScale?.customized_areas_scale.toString() || '0.00',
        customized_areas_scale_title: currentScale?.title || '',
        technology: minTechnologyPrice
      }
      if (calcDssImagePrice != '0') {
        data.dss_image_price = calcDssImagePrice
      }
      isAreaCustomized.value?.push(data)
    } else {
      isAreaCustomized.value[findCurrentEditingIndex].dss_image_price = calcDssImagePrice
    }
  } else {
    isCustomized.value = false
    const tempIndex = isAreaCustomized.value.findIndex((r: CustomPrice) => r.name === currentEditingImage.value?.image.name)
    isAreaCustomized.value.splice(tempIndex, 1)
  }
  canvasActiveObject.value = undefined
  if (deleteUrl && selectedDssThemeList.value.length) {
    const currentSelectedImgs = selectedDssThemeList.value[existingEditingIndex].buyDssThemeList
    currentSelectedImgs.forEach((r: BuyDssTheme) => {
      const deleteImgIndex = r.selectedCustomizedImages.findIndex((res: DssCustomizedImage) => res.image === deleteUrl)
      if (deleteImgIndex >= 0) {
        if (isAreaCustomized.value[findCurrentEditingIndex]?.dss_image_price) {
          isAreaCustomized.value[findCurrentEditingIndex].dss_image_price = new BigNumber(isAreaCustomized.value[findCurrentEditingIndex].dss_image_price!).minus(r.selectedCustomizedImages[deleteImgIndex].ref_price).toFixed(2)
        }
        r.selectedCustomizedImages.splice(deleteImgIndex, 1)
      }
    })
    if (currentSelectedImgs[0].selectedCustomizedImages.length === 0) {
      selectedDssThemeList.value.splice(existingEditingIndex, 1)
    }
    oneditable()
  }
}

const loginSuccess = () => {
  loginVisible.value = !loginVisible.value
}
</script>
<style scoped lang="less">
.modelPreview {
  width: 100%;
  height: 50vh;
}

.external-select {
  width: 200px;
}

.itemDetail {
  width: 220px;
  height: 450px;
  overflow-y: auto;

  img {
    width: 100%;
    height: 200px;
  }

  .title {
    margin-top: 10px;
    overflow: hidden;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
    font-size: 16px;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .detail-txt {
    span:first-child {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FAAD14;
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span:not(:first-child) {
      float: right;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4500);
      line-height: 22px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.custom-spu-designer-content {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-flow: column;
  position: relative;
  overflow: hidden;


  :deep(.ant-tabs-tab) {
    height: 46px;
    width: 195px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
  }

  :deep(.ant-tabs-top > .ant-tabs-nav) {
    margin: 0;
  }

  :deep(.ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn) {
    z-index: 999;
    font-size: 16px;
    font-weight: 400;
    color: #111111 !important;
  }

  :deep(.ant-tabs > .ant-tabs-nav .ant-tabs-nav-wrap) {
    transform: none;
  }

  :deep(.ant-tabs-nav-list) {
    transform: none !important;
  }

  :deep(.ant-tabs-card > .ant-tabs-nav .ant-tabs-tab) {
    border: none;
  }

  .ant-carousel :deep(.slick-slide) {
    text-align: center;
    height: 50vh;
    background: #364d79;
    overflow: hidden;
  }


  .design-top {
    z-index: 999;
    cursor: pointer;
    height: 50px;
    width: 100vw;
    background-image: url(../icon/design-top.png);
    display: flex;
    position: relative;

    .user {
      height: 100%;
      position: absolute;
      right: 30px;
      display: flex;
      align-items: center;

      .login-btn {
        margin-top: 5px;
        color: #fff;
        width: 98px;
        height: 40px;
        background: #00000000;
      }

      :deep(.username) {
        min-width: 60px;
        width: 100%;
        max-width: 20vw;
        color: white;
      }
    }

    // .user-login {
    //   margin-top: 15px;
    // }
    .logo-icon {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .logo {
        width: 222px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }


    .back-icon {
      height: 100%;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .back {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 24px;
        border: 1px solid #99999976;
        color: #99999988;

        img {
          width: 13px;
          height: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .designer {
    flex: 1;
    width: 100vw;
    display: flex;
    justify-content: space-between;
    background: #f6f6f9;
    overflow: hidden;

    :deep(.ant-tabs-content) {
      height: 100%;
    }

    :deep(.ant-tabs-content-holder) {
      height: 100%;
      flex: 1;
    }

    :deep(.ant-tabs) {
      height: 100%;
    }

    .tab-pane {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 300px;
      height: 50px;
      cursor: pointer;


      .tab {
        width: 195px;
        height: 46px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .select {
        background: #F1F1F1;
        font-size: 16px;
        font-family: 'Microsoft YaHei';
        font-weight: 400;
        color: #999999;
      }

      .selected {
        background: #FFFFFF;
        font-size: 16px;
        font-family: 'Microsoft YaHei';
        font-weight: 400;
        color: #111111;
      }
    }

    .myDesign {
      height: 100%;
      flex: 1;
      display: flex;
      position: relative;

      .myDesign-components {
        display: flex;
        flex-flow: column;
        justify-content: space-around;
      }

      .complete {
        z-index: 999;
        width: 100%;
        height: 15%;
        position: absolute;
        bottom: 0;
        flex: 1;
        background: white;
        padding-left: 20px;
        padding-right: 10px;
        display: flex;
        flex-flow: column;

        .complete-button {
          width: 100%;
          height: 40px;
          color: white;
          background: #111111;
          margin-bottom: 5px;
        }
      }

      .asideMenu {
        width: 90px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        text-align: left;
        background-color: #f0f2f5;

        ul {
          font-size: 16px;
          text-align: center;

          li {
            cursor: pointer;
            width: 90px;
            height: 84px;
            padding-top: 14px;

            img {
              width: 28px;
            }

            p {
              font-size: 16px;
              font-weight: 400;
              color: #999999;
            }

            .aside-title-selected {
              color: #111111;
            }
          }

          .active {
            background-color: #ffffff
          }
        }
      }
    }

    .custom-images {
      display: flex;
      position: relative;
      justify-content: space-between;
      padding: 20px;
      flex: 1;
      flex-direction: column;
      overflow: hidden;


      .custom-select {
        display: flex;
        padding: 10px;

        .custom-area {
          display: flex;
          justify-content: space-between;
          margin-right: 20px;
        }

        .custom-item {
          margin-right: 5px;
          width: 68px;
          height: 40px;
          border: none;

          :deep(span) {
            // line-height: 35px;
            width: 100%;
          }
        }
      }

      .editors {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
        overflow: hidden;

        :deep(.ant-spin-nested-loading > div > .ant-spin) {
          top: 50%;
          max-height: 0;
        }

        .hidden {
          display: none;
        }
      }

      .color-list {
        position: absolute;
        right: 20px;
        top: 20px;
        display: flex;
        flex-direction: column;

        .color-item-border {
          min-height: 36px !important;
          min-width: 36px !important;
          margin-bottom: 10px;
          align-items: center;
          display: flex;
          justify-content: space-around;
          border: 1px solid rgb(215, 215, 215);

          .color-item {
            background-size: 100%;
            min-height: 36px !important;
            min-width: 36px !important;
          }

          .selected-color {
            border: 1px solid black;
          }
        }
      }

      .chatWoot {
        position: absolute;
        right: 25px;
        bottom: 25px;
        height: 50px;
        width: 50px;
      }
    }

    .preview {
      width: 300px;
      position: relative;
    }

    .content {
      height: 100%;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px;
    }

    :deep(.ant-tabs-tabpane) {
      display: flex;
    }

    .product-box {
      flex: 1;
      width: 300px;
      overflow: auto;
      background-color: white;
      padding: 15px;

      .product-category {
        font-size: 16px;
        font-weight: 400;
        color: #111111;
      }

      .product-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;

        .product-item {
          background-color: #F6F6F6;
          width: 110px;
          height: 110px;
          gap: 20px;
          margin-bottom: 8px;
          cursor: pointer;

          .product-list-img {
            min-width: 98px;
            min-height: 98px;
            background-size: cover;
          }
        }

        .product-item:nth-child(3n) {
          margin-right: 0px !important;
        }
      }
    }
  }

  :deep(.custom-slick-arrow) {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #a1a3a6;
    transition: ease all 0.3s;
    z-index: 1;
  }

  :deep(.custom-slick-arrow:before) {
    display: none;
  }

  :deep(.custom-slick-arrow:hover) {
    color: black;
    opacity: 0.5;
  }

  :deep(.ant-popover-inner-content) {
    padding: 12px 5px;
  }

  .tutorial {
    z-index: 99;
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.75);

    .tutorial-step-first {
      top: 100px;
      left: 90px;
      background-image: url(../icon/tutorial-01.png);
      background-size: 100% 100%;
    }

    .tutorial-step-second {
      top: 179px;
      left: 414px;
      background-image: url(../icon/tutorial-02.png);
      background-size: 100% 100%;
    }

    .tutorial-step-third {
      top: 179px;
      left: 414px;
      background-image: url(../icon/tutorial-03.png);
      background-size: 100% 100%;
    }

    .tutorial-step-fourth {
      bottom: 90px;
      left: 181px;
      background-image: url(../icon/tutorial-04.png);
      background-size: 100% 100%;
    }

    .tutorial-step-fifth {
      bottom: 90px;
      right: 195px;
      background-image: url(../icon/tutorial-05.png);
      background-size: 100% 100%;
    }


    .tutorial-step {
      width: 308px;
      height: 185px;
      z-index: 9999;
      position: absolute;

      .tutorial-step-title {
        margin-top: 55px;
        margin-left: 20px;
        display: flex;

        img {
          width: 16px;
          height: 16px;
        }

        p {
          width: 240px;
          margin-left: 5px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #111111;
          line-height: 15px;
        }
      }

      .tutorial-step-button {
        float: right;
        display: flex;
        cursor: pointer;

        p {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          margin-top: 40px;
          margin-right: 20px;
        }

        .button {
          margin-top: 30px;
          margin-right: 20px;
          color: #fff;
          width: 68px;
          height: 40px;
          background: #111111;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }

  .tutorial-show {
    z-index: 999;
  }
}
</style>
